import { useClientArea } from '@app/contexts/ClientArea';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { CliqueiAcheiData, Restaurant } from '@app/types';
import { getCityByUrl } from '@app/utils/city';
import { useQueryParamsWithNextRouter } from '@app/utils/routing';
import React, { useMemo } from 'react';
import RestaurantInfoBase from './base';

type Props = {
  data: CliqueiAcheiData;
  restaurant: Restaurant;
};

export default function RestaurantInfoComposed({ data, restaurant }: Props) {
  const {
    timeManager,
    primaryColor,
    isAInternalMenu,
    isAInternalMenuOrOrderedOnRestaurant,
    isOrderedOnRestaurant,
  } = useRestaurantContext();
  const { tableNumber, counterNumber } = useQueryParamsWithNextRouter();
  const { isLoggedIn } = useClientArea();

  const ableDelivery = data?.Entrega;
  const localPickup = Boolean(restaurant?.aceitaRetiradaNoLocal);
  const onlyOnOrder = Boolean(restaurant?.Configuracoes?.apenasEncomenda);
  const delivering = restaurant?.entregandoAgora;

  const listaZapLink = useMemo(() => {
    const city = getCityByUrl(data.Url_Cidade);
    return `https://www.cliqueiachei.com.br/telefone/${city?.Url_Cidade}/${city?.Sigla_UF.toLowerCase()}/${
      data.Url_Cliente
    }`;
  }, [data]);

  const cityLabel = useMemo(() => {
    const city = getCityByUrl(data.Url_Cidade);
    if (!city) return '';
    return ` em ${city.Nom_Cidade}, ${city.Sigla_UF}`;
  }, [data]);

  return (
    <RestaurantInfoBase
      timeManagerIsReady={timeManager.isReady}
      isOpen={timeManager.isOpen()}
      logoURL={data.Url_BannerPagina}
      name={data.NomePuro}
      nameWithActivity={data.Nome}
      cityLabel={cityLabel}
      listaZapLink={listaZapLink}
      categoryName={data.Nom_Categoria}
      primaryColor={primaryColor}
      isAInternalMenu={isAInternalMenu}
      isAInternalMenuOrOrderedOnRestaurant={isAInternalMenuOrOrderedOnRestaurant}
      isOrderedOnRestaurant={isOrderedOnRestaurant}
      ableDelivery={ableDelivery}
      delivering={delivering}
      localPickup={localPickup}
      onlyOnOrder={onlyOnOrder}
      counterNumber={counterNumber}
      tableNumber={tableNumber}
      isLoggedInClientArea={isLoggedIn}
    />
  );
}
